import Message from "../models/Message";

export const createWelcomeMessage = () => {
    const message = "Welcome, enjoy the game and have a fun ❤️";
    return new Message("", "", "iotapoker", "", message);
}
